import gdcConverter from '@gd/currency-converter';
import { Storage, STORE_NAME } from '@gd/storage';
var storage = new Storage();
/**
 * Formates the GD currency
 *
 * The gdc and locale is taken from the storage - so please pass it only if you expect nothing in storage or you
 * would like to explicit overwrite the default.
 * @param value
 */
export default function (value, opt) {
    var storageUser = storage.read(STORE_NAME.USER);
    var gdc = (opt && opt.gdc) || storageUser.currency;
    // if locale is undefined the gdcConverter calculates the locale from a internal gdc to locale map
    var locale = (opt && opt.locale) || storageUser.locale;
    return gdcConverter(value, { gdc: gdc, locale: locale });
}
//# sourceMappingURL=convertGDC.js.map